import type { FC } from 'react';

import { Notification } from '@eneco/components-next/Notification/Notification';
import { StackContainer } from '@eneco/custom-components/selfservice';
import { SelfservicePageTitle } from '@eneco/custom-components/SelfservicePageTitle';
import { Box, PageGrid, Stack, SkipToMain } from '@eneco/sparky';
import { Placeholder, useLayoutData } from '@sitecore/common';

export const NoGridLayout: FC = () => {
  const { route } = useLayoutData();

  const pageTitle =
    typeof route?.fields?.pageTitle?.value === 'string' ? route.fields.pageTitle.value : undefined;
  const hasMain = !!route.placeholders['jss-main']?.length;

  return (
    <>
      <Placeholder name="jss-meta" />

      <StackContainer>
        <SkipToMain.SkipLink targetId="hero-card" />
        <header>
          <Placeholder name="jss-header" />
          <Placeholder name="jss-navigationbar" />
          <Placeholder name="jss-notifications" />
        </header>
        <Stack.Item grow>
          <SkipToMain.Main>
            {pageTitle && pageTitle.length > 0 && (
              <Stack.Item>
                <PageGrid>
                  <PageGrid.Item
                    gridColumn={{ initial: '1/-1', md: `${hasMain ? 4 : 1}/-1`, lg: `${hasMain ? 4 : 1}/10` }}>
                    <SelfservicePageTitle title={pageTitle} />
                  </PageGrid.Item>
                </PageGrid>
              </Stack.Item>
            )}

            <Stack.Item>
              <Placeholder name="jss-no-grid" />

              {hasMain && (
                <PageGrid>
                  <PageGrid.Item gridColumn={{ initial: '1/-1', lg: '1/-1' }} gridRowStart="2">
                    <Box>
                      <Notification />
                      <Stack gap="12">
                        <Placeholder name="jss-main" />
                      </Stack>
                    </Box>
                  </PageGrid.Item>
                </PageGrid>
              )}
            </Stack.Item>
          </SkipToMain.Main>
        </Stack.Item>
        <footer>
          <Box paddingTop="3">
            <Placeholder name="jss-footer" />
          </Box>
        </footer>
      </StackContainer>
    </>
  );
};
